import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const IMG = "https://images.unsplash.com/photo-1775144657626-29ff0a46ca90";
const ease = [0.22, 1, 0.36, 1];

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created. Welcome.");
      navigate("/portal");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  const field = "w-full bg-transparent border-b border-border px-0 py-3 text-bone placeholder:text-bone/30 outline-none focus:border-gold transition-colors duration-300";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-ink">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease }} className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-bone/50 hover:text-bone overline mb-12 transition-colors duration-300"><ArrowLeft size={16} /> Home</Link>
          <div className="serif text-2xl text-bone mb-1">Legacy<span className="text-gold">.</span></div>
          <h1 className="serif font-light text-4xl text-bone tracking-tighter mb-10">Create Account</h1>
          <form onSubmit={submit} data-testid="register-form" className="space-y-8">
            <input required data-testid="register-name" placeholder="Full name" className={field} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <input required type="email" data-testid="register-email" placeholder="Email" className={field} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input required type="password" data-testid="register-password" placeholder="Password" className={field} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <button disabled={loading} data-testid="register-submit" className="w-full py-4 bg-gold text-ink overline hover:bg-bone transition-colors duration-300 disabled:opacity-50">{loading ? "Creating…" : "Create Account"}</button>
          </form>
          <p className="mt-8 text-bone/50 text-sm">Already a client? <Link to="/login" data-testid="to-login" className="text-gold link-underline">Sign in</Link></p>
        </motion.div>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src={IMG} alt="Office" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-ink/50" />
        <div className="absolute bottom-16 left-12 right-12">
          <div className="serif text-4xl text-bone font-light leading-tight">Begin protecting<br />what matters most.</div>
        </div>
      </div>
    </div>
  );
}
